import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { useUpdateDeliveryStateMutation } from "@/services/backend/deliveries/delivery/service";
import { State } from "@/services/backend/deliveries/state/state";
import { useState } from "react";
import { deliveryState } from "@/shared/components/enum-labels";
import { useAuth } from "@/shared/lib/authorization/auth-context";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";

interface UpdateDeliveryStateProps {
  deliveryId: string;
  currentDeliveryState?: string;
  disabled?: boolean;
}

export function UpdateDeliveryState({
  deliveryId,
  currentDeliveryState,
  disabled = false,
}: UpdateDeliveryStateProps) {
  const { user } = useAuth();
  const [state, setState] = useState(currentDeliveryState || "");
  const [updateDeliveryState, { error }] = useUpdateDeliveryStateMutation();

  function onChange(newState: string) {
    if (user) {
      setState(newState);
      updateDeliveryState({
        id: deliveryId,
        state: newState as State,
        employeeId: user?.id as string,
      });
    }
  }

  return (
    <>
      <Select
        disabled={disabled}
        onValueChange={(val) => onChange(val)}
        defaultValue={state}
      >
        <SelectTrigger
          className="w-full"
          defaultValue={currentDeliveryState || "fine"}
        >
          <SelectValue placeholder="Zustand auswählen" />
        </SelectTrigger>
        <SelectContent defaultValue={currentDeliveryState || "fine"}>
          {Object.values(State).map((value) => (
            <SelectItem key={`${deliveryId}-${value}`} value={value}>
              {deliveryState[value]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <RTKQueryErrorAlert error={error} />
    </>
  );
}
